<section class="coming-soon-section">
  <div class="coming-soon-badge" aria-hidden="true">
    <img
      src="assets/img/Group (3).png"
      alt=""
      class="coming-soon-badge-img"
    />
  </div>

  <div class="section-inner coming-soon-inner">
    <div class="coming-soon-cards-wrap">
      <div class="coming-soon-cards">
        <div class="cs-card" *ngFor="let feature of comingSoonFeatures">
          <div class="cs-icon-wrap">
            <i class="bi bi-briefcase-fill"></i>
          </div>
          <h3 class="cs-title">{{ feature.title }}</h3>
          <p class="cs-desc">{{ feature.desc }}</p>
          <a href="#" class="cs-learn-more">Learn more <i class="bi bi-arrow-right"></i></a>
        </div>
      </div>
    </div>
  </div>
</section>